export default "__VITE_ASSET__CKdjTJfs__"